import { M8Currency, M8RateDTO } from 'services/production/types';
import { createQueryString } from 'services/production/utils/createQueryString';
import { getM8AdminURL } from 'services/production/utils/getM8URL';
import { HTTPResponseError } from 'utils/errors';
import { customFetch } from 'utils/http';

type Params = {
  currencyFrom: M8Currency;
  currencyTo: M8Currency;
  rateDate: string;
};

export const getRateOn = async (params: Params): Promise<null | M8RateDTO> => {
  const response = await customFetch(
    getM8AdminURL(`getRateOn?${createQueryString(params)}`)
  );

  if (!response.ok) {
    throw new HTTPResponseError(response);
  }

  if (response.status === 200) {
    return response.json();
  }

  return null;
};
